/**
 * @Author : DingHuiHui
 * @Content : 我的账户
 */
import Vue from 'vue'
import axios from 'axios'
import fetch from '@/utils/fetch2'
import AES from '@/utils/aes'

const adminUrl = process.env.VUE_APP_REPORTURL + 'admin/v1'

export const apiMy = {
  // 修改基本信息
  base (params) {
    return new Promise((resolve, reject) => {
      axios.post(`${Vue.prototype.$config.baseOAuthUrl}v1/user/modify`, params,
        {
          headers: {
            accesstoken: AES.Decrypt(Vue.prototype.$cookies.get('access_token'))
          }
        }
      ).then(res => {
        if (res.data.code === 0) {
          resolve(res.data.result)
        } else {
          reject(res.data)
        }
      })
    })
  },
  // 上传头像
  uploadHead (params) {
    return new Promise((resolve, reject) => {
      axios.post(`${Vue.prototype.$config.baseOAuthUrl}v1/user/favicon`, params,
        {
          headers: {
            accesstoken: AES.Decrypt(Vue.prototype.$cookies.get('access_token'))
          }
        }
      ).then(res => {
        if (res.data.code === 0) {
          resolve(res.data.result)
        } else {
          reject(res.data)
        }
      })
    })
  },
  // 账户解绑
  unbind (bindType) {
    return new Promise((resolve, reject) => {
      axios.post(`${Vue.prototype.$config.baseOAuthUrl}v1/user/unbind/${bindType}`, {},
        {
          headers: {
            accesstoken: AES.Decrypt(Vue.prototype.$cookies.get('access_token'))
          }
        }
      ).then(res => {
        if (res.data.code === 0) {
          resolve(res.data.result)
        } else {
          reject(res.data)
        }
      })
    })
  },
  // 获取已推荐用户数
  recommendedNum () {
    return fetch.get(adminUrl + '/user/recommeds')
  }
}
